import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "journey", "ticket", "ticketBoard", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--products--purchases--entities--tickets`
    this.blockedAdd = false
  }

  doTicketsDashboard() {
    var html = `<div class="col-12 pl-1" data-users--works--activities--shared--tickets-target="main" data-controller="users--works--activities--shared--tickets"></div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.ticketBoardTarget.innerHTML = html)
    }).then(() => {

      var partyName = ``
      controller.application.purchase.parties.forEach(party => {
        partyName += `| ${party.party_name} `
      })

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).permission = `financial_purchase_tickets`
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).blockedAdd = controller.blockedAdd
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).sharing = false
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).kind = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).priority = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).term = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).itemsOnRow = 4
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).ticket_board = {
        board_id: controller.application.purchase.id,
        board_type: `products_purchases`,
        // board_subtype: `${controller.application.purchase.product_name}`,
        board_path: window.location.pathname,
        board_name: `Contratação ${controller.application.purchase.product_accrual_name_pretty} ${partyName}`,
        date_id: controller.application.purchase.date_id,
        date_type: `financials_dates`
      }
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).comment_board = {
        board_id: controller.application.purchase.id,
        board_type: `products_purchases`,
        date_id: controller.application.purchase.date_id,
        date_type: `financials_dates`
      }

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}